// extracted by mini-css-extract-plugin
export default {"loadingIcon":"style_loadingIcon__9tLqy"};